// extracted by mini-css-extract-plugin
module.exports = {"list":"_1is022xF","listItem":"_2rEPZ2Wb _3mW2gstu","iconContainer":"guy8-aDe H6On8Sx7 ThkJbd5K qCnGG6r0 _1X0dhxAa _20CSxUpk","subtitle":"_37BG5yhO _1d0WKk0g"};